module.exports = __webpack_public_path__ + "img/info.a709ad87.svg";